import React from "react";
import useLocalStorage from "../../Hooks/getLocalStorageData";
import Classes from "./styles/style.module.css";
import NavElement from "./NavElement";
import useLoginActions from "../../Hooks/Login";

const NavUtils = ({ user }) => {
  const { version } = useLocalStorage();
  const { handleLogout } = useLoginActions();

  return (
    <div className="w-100">
      <div className={Classes.NavUtitsContainer}>
        {user ? (
          <NavElement
            text={"خروج از حساب کاربری"}
            clickHandler={() => handleLogout()}
          />
        ) : (
          <NavElement
            isLink={true}
            link={"/profile"}
            text={"ورود به حساب کاربری"}
          />
        )}
      </div>
      <div className={Classes.versionContainer}>
        {`Royinsoft | ${version !== "null" ? "Version "+version+"|"  : ""} Revision ${process.env.REACT_APP_REVISION || "revnd"}`}
      </div>
    </div>
  );
};

export default NavUtils;
